import { Container, Modal } from "react-bootstrap";
import PrimaryButton, {
  SecondaryButton,
} from "../../../util/Btns/PrimaryButton";

import Close from "../../../Assets/close.svg";
import styles from "./DeleteBuildModal.module.scss";
import { useDeleteUser } from "../../../hooks/DevAuthHooks";

const RemoveMember = ({ showRemoveMember, setShowRemoveMember, member }) => {
  const handleClose = () => setShowRemoveMember(false);
  const { mutate } = useDeleteUser(member.id);
  const handleSubmit = () => {
    mutate();
  };
  return (
    <>
      <Container>
        <Modal
          show={showRemoveMember}
          onHide={handleClose}
          centered
          contentClassName={styles.content}
          dialogClassName={styles.dialog}
        >
          <Modal.Header className={styles.header}>
            <Modal.Title>
              <div style={{ padding: "0.25em" }}>
                <span
                  style={{ fontFamily: "JioType-Medium", fontSize: "medium" }}
                >
                  Remove Member from the Organization
                </span>
              </div>
            </Modal.Title>

            <img
              onClick={() => setShowRemoveMember(false)}
              style={{ marginTop: "15px" }}
              src={Close}
              height="14"
              width="14"
              alt="cross"
              className="cursor-pointer"
            />
          </Modal.Header>

          <Modal.Body>
            <div className={styles.body}>
              <h4>Are you sure you want to remove {member.firstName? member.firstName + " " + (member.lastName?member.lastName:""): member.email} ?</h4>
              <div className={styles.buttonContainer}>
                <SecondaryButton onClick={() => setShowRemoveMember(false)}>
                  Cancel
                </SecondaryButton>
                <PrimaryButton
                  onClick={() => {
                    handleSubmit();
                    setShowRemoveMember(false);
                  }}
                >
                  Remove
                </PrimaryButton>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
};

export default RemoveMember;
